<div class="benefits-wrap"
     [class.benefits-company]="isCompany">
  <div class="benefits-item">
    <div class="benefits-img">
      <img src="/assets/img/benefits/hand-made.png"
           [alt]="('modal.howItWorks.benefits.handMade' | translate) + ' | Cake it easy'">
    </div>

    <ng-template [ngTemplateOutlet]="handMadeCompany"
                 *ngIf="isCompany; else handMade"></ng-template>
  </div>

  <div class="benefits-item">
    <div class="benefits-img">
      <img src="/assets/img/benefits/same-price.png"
           [alt]="('modal.howItWorks.benefits.samePrice' | translate) + ' | Cake it easy'">
    </div>
    <ng-template [ngTemplateOutlet]="samePriceCompany"
                 *ngIf="isCompany; else samePrice"></ng-template>
  </div>

  <div class="benefits-item">
    <div class="benefits-img">
      <img src="/assets/img/benefits/send-cakes.png"
           [alt]="('modal.howItWorks.benefits.sendCakes' | translate) + ' | Cake it easy'">
    </div>
    <ng-template [ngTemplateOutlet]="sendCakesCompany"
                 *ngIf="isCompany; else sendCakes"></ng-template>
  </div>
</div>


<ng-template #handMade>
  <h2 class="d-none d-md-block"
      [innerHTML]="'modal.howItWorks.benefits.handMade' | translate"></h2>

  <h2 class="d-sm-block d-md-none"
      [innerHTML]="'modal.howItWorks.benefits.handMadeForMobile' | translate"></h2>
</ng-template>

<ng-template #samePrice>
  <h2 class="d-none d-md-block"
      [innerHTML]="'modal.howItWorks.benefits.samePrice' | translate"></h2>

  <h2 class="d-sm-block d-md-none"
      [innerHTML]="'modal.howItWorks.benefits.samePriceForMobile' | translate"></h2>
</ng-template>

<ng-template #sendCakes>
  <h2 class="d-none d-md-block"
      [innerHTML]="'modal.howItWorks.benefits.sendCakes' | translate"></h2>

  <h2 class="d-sm-block d-md-none"
      [innerHTML]="'modal.howItWorks.benefits.sendCakesForMobile' | translate"></h2>
</ng-template>

<ng-template #handMadeCompany>
  <h2 [innerHTML]="'homeCompany.benefits.handMade.title' | translate">Simple ordering</h2>

  <div class="benefits-point-desc mt-2 fw-normal"
       [innerHTML]="'homeCompany.benefits.handMade.description' | translate">
    Find your city, choose a cake and <br>
    customize it to your occasion. You do <br>
    not need an account - just order.
  </div>
</ng-template>

<ng-template #samePriceCompany>
  <h2 [innerHTML]="'homeCompany.benefits.samePrice.title' | translate">Invoice or card</h2>

  <div class="benefits-point-desc mt-2 fw-normal"
       [innerHTML]="'homeCompany.benefits.samePrice.description' | translate">
    Simple payment with invoice, credit<br>
    card or Vipps. Same price as from<br> the bakery.
  </div>
</ng-template>

<ng-template #sendCakesCompany>
  <h2 [innerHTML]="'homeCompany.benefits.sendCakes.title' | translate">Fresh and local</h2>

  <div class="benefits-point-desc mt-2 fw-normal"
       [innerHTML]="'homeCompany.benefits.sendCakes.description' | translate">
    The cake is handmade by the local<br>
    baker. Choose if you want it delivered <br>
    or if you want to pick it up.
  </div>
</ng-template>
